<template>
  <div class="lib__form__main" data-cy="car-specification-component">
    <div class="lib__form__main__content">
      <ValidationObserver ref='validator' slim>
        <electric-vehicle-selected-form v-if="!!stateElectricVehicle" :value="stateElectricVehicle"></electric-vehicle-selected-form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script lang="ts">
import ElectricVehicleSelectedForm from '@/components/inputs/EMobility/Car/ElectricVehicleSelectedForm.vue'
import Step from '@/components/steps/Step'
import { ElectricVehicle } from '@/models'
import { Component } from 'vue-property-decorator'
import { State } from 'vuex-class'

@Component({
  components: {
    ElectricVehicleSelectedForm
  },
  name: 'car-selected-step'
})
export default class CarSelectedStep extends Step {
  //#region [Data]
  @State('electricVehicle', { namespace: 'eMobility/carSpecification' })
  public stateElectricVehicle!: ElectricVehicle | null
  //#endregion

  //#region [Method]
  public mounted(): void {
    if (this.stateElectricVehicle === null) {
      if (this.isBack) {
        this.previous()
      } else {
        this.setIsBack(false)
        this.next()
      }
    }
  }
  //#endregion
}
</script>